/**
 * User status values
 */
export enum UserStatusEnum {
	/**
	 * User is active
	 */
	ACTIVE = 'active',
	/**
	 * User is inactive
	 */
	INACTIVE = 'inactive',
}
